import { UserStateParams } from '../config';
import { IDataAlertInfo } from '../models/IDataAlertInfo';
import { IUserInfo } from '../models/IUserInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { DataAlerts } from '../resources/DataAlerts';
import { IResult } from '../ServerApi/types/IResponse';
import { AddSelfToAlertsAction } from '../services/AddSelfToAlertsAction';
import { ServerService } from '../services/ServerService';

export interface RemoveUserFromDataAlertScope extends ng.IScope {
  dataAlert: IDataAlertInfo;
  errorOccurred: boolean;
  actionSuccessful: boolean;
  errorOrSuccessMessage: string;
  userStateParams: UserStateParams;
  undoMessage: string;
  undo: () => void;
}

export interface RemoveUserFromDataAlertStateParams extends ng.ui.IStateParamsService {
  dataAlertId: string;
  userId: string;
}

export class RemoveUserFromDataAlertCtrl {

  public static $inject = [
    '$scope',
    '$state',
    '$translate',
    '$stateParams',
    'DataAlerts',
    'ServerService',
    'AddSelfToAlertsAction'
  ];

  public initComplete: ng.IPromise<void>;

  constructor(private $scope: RemoveUserFromDataAlertScope,
              $state: ng.ui.IStateService,
              private $translate: ng.translate.ITranslateService,
              $stateParams: RemoveUserFromDataAlertStateParams,
              private DataAlerts: DataAlerts,
              ServerService: ServerService,
              private AddSelfToAlertsAction: AddSelfToAlertsAction) {

    $scope.errorOccurred = false;
    $scope.actionSuccessful = false;
    $scope.undoMessage = $translate.instant('removeSelfFromDataAlertThroughEmailAddMeBack');

    const currentUser = ServerService.sessionUserInfo();
    $scope.userStateParams = {
      domainName: currentUser.domainName,
      username: currentUser.username
    };

    $scope.undo = () => {
      return this.AddSelfToAlertsAction.addSelf(Set.singletonForIdItem(this.$scope.dataAlert), { scope: $scope })
        .then(() => $state.go('main.site.user.dataAlerts', $scope.userStateParams, { location: 'replace' }));
    };

    this.initComplete = DataAlerts.getById($stateParams.dataAlertId)
      .then((dataAlert: IDataAlertInfo) => {
        if (dataAlert) {
          this.$scope.dataAlert = dataAlert;
          if (!dataAlert.isCurrentUserSubscribed) {
            this.handleUserAlreadyRemovedFromAlert(dataAlert);
          } else {
            this.tryToRemoveUserFromAlert(dataAlert, currentUser);
          }
        } else {
          this.handleAlertNotFound();
        }
      })
      .catch(()=> {
        this.handleUnknownError();
      });
  }

  private tryToRemoveUserFromAlert(dataAlert: IDataAlertInfo, currentUser: IUserInfo) {
    this.DataAlerts.removeUsers({ dataAlertIds: [ dataAlert.id ], userIds: [ currentUser.id ] })
      .then((result: IResult) => {
        if (result.errors && result.errors.length > 0) {
          this.handleRemoveSelfError(dataAlert);
        } else {
          this.handleRemoveSelfSuccess(dataAlert);
        }
      })
      .catch(() => {
        this.handleUnknownError();
      });
  }

  private handleAlertNotFound() {
    this.$scope.errorOccurred = true;
    this.$scope.errorOrSuccessMessage = this.$translate.instant('errorDataAlertNotFoundNoName');
  }

  private handleUserAlreadyRemovedFromAlert(dataAlert: IDataAlertInfo) {
    // Don't set the errorOccurred flag here because this case is success-ish
    this.$scope.actionSuccessful = true;
    this.$scope.errorOrSuccessMessage = this.$translate.instant(
        'removeSelfFromDataAlertsErrorAlreadyRemoved', { ALERT_NAME: dataAlert.name });
  }

  private handleRemoveSelfSuccess(dataAlert: IDataAlertInfo) {
    this.$scope.actionSuccessful = true;
    this.$scope.errorOrSuccessMessage = this.$translate.instant(
      'removeSelfFromDataAlertThroughEmailSuccess', { ALERT_NAME: dataAlert.name });
  }

  private handleRemoveSelfError(dataAlert: IDataAlertInfo) {
    this.$scope.errorOccurred = true;
    this.$scope.errorOrSuccessMessage = this.$translate.instant(
      'removeSelfFromDataAlertThroughEmailError', { ALERT_NAME: dataAlert.name });
  }
  private handleUnknownError() {
    this.$scope.errorOccurred = true;
    this.$scope.errorOrSuccessMessage = this.$translate.instant('errorUnknown');
  }
}

Module.instance().controller('RemoveUserFromDataAlertCtrl', RemoveUserFromDataAlertCtrl);

